// @flow
import * as React from 'react';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import { type Map } from 'esm-web-pro/containers/map/types';
import { ObjectContext } from 'esm-web-pro/containers/map/MapObject';
import { Accordion } from 'grommet';
import AccordionPanel from 'esm-web-pro/components/layout/sidePanel/AccordionPanel';
import { FormattedMessage } from 'react-intl';
import CablePaths from 'esm-web-pro/containers/pages/network/objects/cable/CablePaths';
import CablePathsPermitDocuments from 'esm-web-pro/containers/pages/network/objects/cable/CablePathsPermitDocuments';
import FiberList from './cable/FiberList';

type Props = {
    cable: Object,
    editor: BaseEditor,
    map: Map,
    highlightFiber: Function,
    highlightCable: Function,
    clicked: string,
    setClicked: Function,
}

const CableContent = (props: Props) => {
    const {
        cable, editor, map, highlightFiber, clicked, setClicked, highlightCable,
    } = props;
    const { connected_fibers: connectedFibers, damaged_fibers: damagedFibers, free_fibers: freeFibers } = cable;

    const [activeIndices, setActiveIndices] = React.useState([0]);
    const { reload } = React.useContext(ObjectContext);
    const { cable_path: { cable_paths: cablePaths } } = cable;

    return (
        <Accordion activeIndex={activeIndices} onActive={setActiveIndices}>
            <AccordionPanel
                label={(
                    <FormattedMessage
                        id="networks-fiber-fibers"
                        defaultMessage="Fibers"
                    />
                )}
            >
                <FiberList
                    cable={cable}
                    connectedFibers={connectedFibers}
                    damagedFibers={damagedFibers}
                    freeFibers={freeFibers}
                    editor={editor}
                    map={map}
                    reload={reload}
                    highlightFiber={highlightFiber}
                    clicked={clicked}
                    setClicked={setClicked}
                />
            </AccordionPanel>
            <AccordionPanel
                label={(
                    <FormattedMessage
                        id="cable-segments"
                        defaultMessage="Segments"
                    />
                )}
            >
                <CablePaths
                    cablePaths={cablePaths}
                    clicked={clicked}
                    setClicked={setClicked}
                    highlightCable={highlightCable}
                />
            </AccordionPanel>
            <AccordionPanel
                label={(
                    <FormattedMessage
                        id="permit-documents"
                        defaultMessage="Permit documents"
                    />
                )}
            >
                <CablePathsPermitDocuments
                    cablePaths={cablePaths}
                    reload={reload}
                />
            </AccordionPanel>
        </Accordion>
    );
};

export default CableContent;
